import React, { useState } from 'react';
import { LayoutDashboardIcon, HomeIcon, ClipboardCheckIcon, TruckIcon, MessageSquareIcon, SettingsIcon, BuildingIcon, CalendarIcon, CheckCircleIcon, AlertCircleIcon, ClockIcon, FileTextIcon, UserIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
// Mock data
const transactions = [{
  id: 1,
  propertyName: 'Luxury 3 Bedroom Apartment',
  location: 'Lekki Phase 1, Lagos',
  price: '₦75,000,000',
  status: 'In Progress',
  image: 'https://images.unsplash.com/photo-1613545325278-f24b0cae1224?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
  progress: 65,
  stages: [{
    name: 'Property Selected',
    completed: true
  }, {
    name: 'Payment Initiated',
    completed: true
  }, {
    name: 'Legal Verification',
    completed: true
  }, {
    name: 'Document Processing',
    completed: false
  }, {
    name: 'Key & Document Delivery',
    completed: false
  }]
}, {
  id: 2,
  propertyName: 'Modern 4 Bedroom Duplex',
  location: 'Maitama, Abuja',
  price: '₦120,000,000',
  status: 'Legal Verification',
  image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
  progress: 40,
  stages: [{
    name: 'Property Selected',
    completed: true
  }, {
    name: 'Payment Initiated',
    completed: true
  }, {
    name: 'Legal Verification',
    completed: false
  }, {
    name: 'Document Processing',
    completed: false
  }, {
    name: 'Key & Document Delivery',
    completed: false
  }]
}];
const upcomingEvents = [{
  id: 1,
  title: 'Virtual Tour - Ikoyi Penthouse',
  date: 'Tomorrow, 2:00 PM',
  type: 'tour'
}, {
  id: 2,
  title: 'Document Signing - Lekki Property',
  date: 'May 15, 10:00 AM',
  type: 'document'
}, {
  id: 3,
  title: 'Key Delivery - Maitama Duplex',
  date: 'May 20, 3:30 PM',
  type: 'delivery'
}];
const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('overview');
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-1096">
      <div className="container mx-auto px-4 py-8" data-id="element-1097">
        <h1 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-1098">Dashboard</h1>
        <div className="flex flex-col md:flex-row space-y-6 md:space-y-0 md:space-x-6" data-id="element-1099">
          {/* Sidebar */}
          <div className="md:w-1/4 lg:w-1/5" data-id="element-1100">
            <div className="bg-white rounded-lg shadow-sm p-4" data-id="element-1101">
              <div className="flex items-center space-x-3 p-2 mb-6" data-id="element-1102">
                <div className="w-10 h-10 rounded-full bg-[#FFF1EC] flex items-center justify-center" data-id="element-1103">
                  <UserIcon className="h-6 w-6 text-[#FF4E00]" data-id="element-1104" />
                </div>
                <div data-id="element-1105">
                  <p className="font-medium" data-id="element-1106">Oluwaseun Adeyemi</p>
                  <p className="text-sm text-gray-600" data-id="element-1107">Verified Buyer</p>
                </div>
              </div>
              <nav className="space-y-1" data-id="element-1108">
                <SidebarLink icon={<LayoutDashboardIcon size={18} data-id="element-1110" />} label="Overview" active={activeTab === 'overview'} onClick={() => setActiveTab('overview')} data-id="element-1109" />
                <SidebarLink icon={<HomeIcon size={18} data-id="element-1112" />} label="My Properties" active={activeTab === 'properties'} onClick={() => setActiveTab('properties')} data-id="element-1111" />
                <SidebarLink icon={<ClipboardCheckIcon size={18} data-id="element-1114" />} label="Transactions" active={activeTab === 'transactions'} onClick={() => setActiveTab('transactions')} data-id="element-1113" />
                <SidebarLink icon={<TruckIcon size={18} data-id="element-1116" />} label="Deliveries" active={activeTab === 'deliveries'} onClick={() => setActiveTab('deliveries')} data-id="element-1115" />
                <SidebarLink icon={<MessageSquareIcon size={18} data-id="element-1118" />} label="Messages" active={activeTab === 'messages'} onClick={() => setActiveTab('messages')} badge="3" data-id="element-1117" />
                <SidebarLink icon={<SettingsIcon size={18} data-id="element-1120" />} label="Settings" active={activeTab === 'settings'} onClick={() => setActiveTab('settings')} data-id="element-1119" />
              </nav>
            </div>
          </div>
          {/* Main Content */}
          <div className="md:w-3/4 lg:w-4/5" data-id="element-1121">
            {activeTab === 'overview' && <>
                {/* Stats */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-1122">
                  <StatCard icon={<BuildingIcon className="h-6 w-6 text-[#FF4E00]" data-id="element-1124" />} title="Properties" value="2" subtitle="In progress" data-id="element-1123" />
                  <StatCard icon={<ClipboardCheckIcon className="h-6 w-6 text-blue-600" data-id="element-1126" />} title="Transactions" value="₦195M" subtitle="Total value" data-id="element-1125" />
                  <StatCard icon={<FileTextIcon className="h-6 w-6 text-purple-600" data-id="element-1128" />} title="Documents" value="8" subtitle="Verified" data-id="element-1127" />
                  <StatCard icon={<TruckIcon className="h-6 w-6 text-orange-600" data-id="element-1130" />} title="Deliveries" value="1" subtitle="In transit" data-id="element-1129" />
                </div>
                {/* Transactions */}
                <div className="bg-white rounded-lg shadow-sm p-6 mb-8" data-id="element-1131">
                  <div className="flex justify-between items-center mb-6" data-id="element-1132">
                    <h2 className="text-xl font-bold" data-id="element-1133">Current Transactions</h2>
                    <Link to="/dashboard/transactions" className="text-[#FF4E00] hover:underline text-sm" data-id="element-1134">
                      View All
                    </Link>
                  </div>
                  <div className="space-y-6" data-id="element-1135">
                    {transactions.map(transaction => <div key={transaction.id} className="border-b pb-6 last:border-b-0 last:pb-0" data-id="element-1136">
                        <div className="flex flex-col md:flex-row md:items-center space-y-4 md:space-y-0" data-id="element-1137">
                          <div className="md:w-1/4" data-id="element-1138">
                            <img src={transaction.image} alt={transaction.propertyName} className="w-full h-24 object-cover rounded-lg" data-id="element-1139" />
                          </div>
                          <div className="md:w-3/4 md:pl-6" data-id="element-1140">
                            <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-3" data-id="element-1141">
                              <div data-id="element-1142">
                                <h3 className="font-bold text-lg" data-id="element-1143">
                                  {transaction.propertyName}
                                </h3>
                                <p className="text-gray-600" data-id="element-1144">
                                  {transaction.location}
                                </p>
                              </div>
                              <div className="mt-2 md:mt-0" data-id="element-1145">
                                <span className="font-bold text-[#FF4E00]" data-id="element-1146">
                                  {transaction.price}
                                </span>
                              </div>
                            </div>
                            <div className="mb-4" data-id="element-1147">
                              <div className="flex justify-between mb-1" data-id="element-1148">
                                <span className="text-sm text-gray-600" data-id="element-1149">
                                  Progress
                                </span>
                                <span className="text-sm font-medium" data-id="element-1150">
                                  {transaction.progress}%
                                </span>
                              </div>
                              <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-1151">
                                <div className="bg-[#FF4E00] h-2 rounded-full" style={{
                            width: `${transaction.progress}%`
                          }} data-id="element-1152"></div>
                              </div>
                            </div>
                            <div className="flex flex-wrap gap-2" data-id="element-1153">
                              {transaction.stages.map((stage, index) => <div key={index} className={`flex items-center px-2 py-1 rounded-full text-xs ${stage.completed ? 'bg-[#FFF1EC] text-[#FF4E00]' : index === transaction.stages.findIndex(s => !s.completed) ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-600'}`} data-id="element-1154">
                                  {stage.completed ? <CheckCircleIcon size={12} className="mr-1" data-id="element-1155" /> : index === transaction.stages.findIndex(s => !s.completed) ? <ClockIcon size={12} className="mr-1" data-id="element-1156" /> : <AlertCircleIcon size={12} className="mr-1" data-id="element-1157" />}
                                  {stage.name}
                                </div>)}
                            </div>
                          </div>
                        </div>
                      </div>)}
                  </div>
                </div>
                {/* Upcoming Events */}
                <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-1158">
                  <div className="flex justify-between items-center mb-6" data-id="element-1159">
                    <h2 className="text-xl font-bold" data-id="element-1160">Upcoming Events</h2>
                    <Link to="/dashboard/calendar" className="text-[#FF4E00] hover:underline text-sm" data-id="element-1161">
                      View Calendar
                    </Link>
                  </div>
                  <div className="space-y-4" data-id="element-1162">
                    {upcomingEvents.map(event => <div key={event.id} className="flex items-center p-3 hover:bg-gray-50 rounded-lg" data-id="element-1163">
                        <div className="mr-4" data-id="element-1164">
                          {event.type === 'tour' ? <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-1165">
                              <HomeIcon size={20} className="text-blue-600" data-id="element-1166" />
                            </div> : event.type === 'document' ? <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center" data-id="element-1167">
                              <FileTextIcon size={20} className="text-purple-600" data-id="element-1168" />
                            </div> : <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center" data-id="element-1169">
                              <TruckIcon size={20} className="text-orange-600" data-id="element-1170" />
                            </div>}
                        </div>
                        <div className="flex-grow" data-id="element-1171">
                          <h3 className="font-medium" data-id="element-1172">{event.title}</h3>
                          <div className="flex items-center text-sm text-gray-600" data-id="element-1173">
                            <CalendarIcon size={14} className="mr-1" data-id="element-1174" />
                            {event.date}
                          </div>
                        </div>
                        <button className="text-[#FF4E00] hover:text-[#e64600]" data-id="element-1175">
                          Details
                        </button>
                      </div>)}
                  </div>
                </div>
              </>}
            {activeTab !== 'overview' && <div className="bg-white rounded-lg shadow-sm p-8 text-center" data-id="element-1176">
                <h2 className="text-xl font-bold mb-2" data-id="element-1177">
                  {activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}{' '}
                  Section
                </h2>
                <p className="text-gray-600 mb-4" data-id="element-1178">
                  This section is under development. Please check back later.
                </p>
                <button className="px-4 py-2 bg-[#FF4E00] text-white rounded-lg hover:bg-[#e64600] transition" onClick={() => setActiveTab('overview')} data-id="element-1179">
                  Return to Overview
                </button>
              </div>}
          </div>
        </div>
      </div>
    </div>;
};
interface SidebarLinkProps {
  icon: React.ReactNode;
  label: string;
  active: boolean;
  onClick: () => void;
  badge?: string;
}
const SidebarLink: React.FC<SidebarLinkProps> = ({
  icon,
  label,
  active,
  onClick,
  badge
}) => <button className={`flex items-center justify-between w-full p-2 rounded-lg ${active ? 'bg-[#FFF1EC] text-[#FF4E00]' : 'text-gray-700 hover:bg-gray-50'}`} onClick={onClick} data-id="element-1180">
    <div className="flex items-center" data-id="element-1181">
      <span className="mr-3" data-id="element-1182">{icon}</span>
      <span data-id="element-1183">{label}</span>
    </div>
    {badge && <span className="bg-[#FF4E00] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center" data-id="element-1184">
        {badge}
      </span>}
  </button>;
interface StatCardProps {
  icon: React.ReactNode;
  title: string;
  value: string;
  subtitle: string;
}
const StatCard: React.FC<StatCardProps> = ({
  icon,
  title,
  value,
  subtitle
}) => <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-1185">
    <div className="flex items-center mb-4" data-id="element-1186">
      <div className="mr-4" data-id="element-1187">{icon}</div>
      <h3 className="font-medium text-gray-600" data-id="element-1188">{title}</h3>
    </div>
    <div className="flex items-end justify-between" data-id="element-1189">
      <div data-id="element-1190">
        <p className="text-2xl font-bold" data-id="element-1191">{value}</p>
        <p className="text-sm text-gray-600" data-id="element-1192">{subtitle}</p>
      </div>
    </div>
  </div>;
export default Dashboard;